import script from "./FleetSecurityBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./FleetSecurityBoard.vue?vue&type=script&setup=true&lang=js"

import "./FleetSecurityBoard.vue?vue&type=style&index=0&id=75281db8&lang=scss"

const __exports__ = script;

export default __exports__